// extracted by mini-css-extract-plugin
export var measureBox = "_8q-0";